
import React, { useState } from "react";
import AIChatButton from "./AIChatButton";
import AIChatPanel from "./AIChatPanel";

export default function AIAssistant() {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <>
      {isOpen && (
        <AIChatPanel onClose={() => setIsOpen(false)} />
      )}

      <AIChatButton
        isOpen={isOpen}
        onClick={() => setIsOpen((previous) => !previous)}
      />
    </>
  );
}
